export default __webpack_public_path__ + "static/media/wow-grey.c164041c.svg";